import { ArrayHelpers } from "@common/ArrayHelpers";
import { getServiceParamValue } from "@common/serviceParamsHelper";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { TicketAdminGroupType } from "@share/ticketSystem/enums/TicketAdminGroupTypes";
import { TicketType } from "@share/ticketSystem/enums/TicketTypes";

export const getTicketType = (routeName: string | null | undefined) => {
    if (routeName) {
        return ([
            RouteNamesEnum.ticketSystemIdeas,
            RouteNamesEnum.ticketSystemIdeaEdit,
            RouteNamesEnum.ticketSystemIdeaView,
            RouteNamesEnum.ticketSystemIdeaCreate
        ] as string[]).includes(routeName) ? TicketType.idea : TicketType.problem;
    }
    return TicketType.idea;
}

export const getIsTicketAdmin = (routeName: string | null | undefined, groupIds?: string[], ticketType?: TicketType) => {
    let groupsParamName = "";
    const IDEAS_GROUPS_PARAM_NAME = TicketAdminGroupType.ideasAdministrationGroupIds;
    const PROBLEMS_GROUP_PARAM_NAME = TicketAdminGroupType.problemsAdministrationGroupIds;
    if(ticketType) {
        groupsParamName = ticketType === TicketType.idea ? IDEAS_GROUPS_PARAM_NAME : PROBLEMS_GROUP_PARAM_NAME;
    }
    else {
        switch (routeName) {
            case RouteNamesEnum.ticketSystemIdeas:
            case RouteNamesEnum.ticketSystemIdeaCreate:
            case RouteNamesEnum.ticketSystemIdeaEdit:
                groupsParamName = IDEAS_GROUPS_PARAM_NAME;
                break;

            case RouteNamesEnum.ticketSystemProblems:
            case RouteNamesEnum.ticketSystemProblemCreate:
            case RouteNamesEnum.ticketSystemProblemEdit:
                groupsParamName = PROBLEMS_GROUP_PARAM_NAME;
                break;

            default:
                break;
        }
    }

    if (groupsParamName) {
        const adminGroups = getServiceParamValue('ticketSystem', groupsParamName) ?? [];
        if (Array.isArray(adminGroups)) {
            return ArrayHelpers.intersect(adminGroups, groupIds || []).length > 0;
        }
    }

    return false;
}

export const getIsCommitteeAllowed = (groupIds?: string[]) => {
    const adminGroups = getServiceParamValue('ticketSystem', "committeeAllowedGroupIds") ?? [];
    if (Array.isArray(adminGroups)) {
        return ArrayHelpers.intersect(adminGroups, groupIds || []).length > 0;
    }

    return false;
}